import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environments/environment.debug';

@Component({
  selector: 'app-welcome-relateduser',
  templateUrl: './welcome-relateduser.component.html',
  styleUrls: ['./welcome-relateduser.component.scss']
})
export class WelcomeRelateduserComponent {
  uniqueUserId: string | null = null;
  vacancyId: string | null = null;
  talent : any = null;

  constructor(private route: ActivatedRoute, private router: Router,private apiService: ApiService) {
    this.uniqueUserId = this.route.snapshot.paramMap.get('unique-user-id');
    this.vacancyId = this.route.snapshot.paramMap.get('vacancyId');
  }


  startSignup() {
    this.apiService.getTalentEmailAndVacancyId(this.uniqueUserId).subscribe(
      (talent: any) => {
        if (!talent?.email || !talent?.vacancyId) {
          console.error('Email and VacancyId not found', talent?.email, talent?.vacancyId);
          return;
        }
        const email = talent.email;
          const url = `dashboard/vacancies/${talent.vacancyId}`;
        localStorage.setItem('onboard', url);
        this.router.navigate(['/'], {
          queryParams: {
            email,
            state: `${environment.ssoAllowedOrigins}onboarding/talent/general?userId=${this.uniqueUserId}&vacancyId=${talent.vacancyId}`
          }
        });
      },
      (error) => {
        console.error('Error fetching talent data:', error);
      }
    );
  }
  
}
